import { sendDataToParent } from '../../../../base/functions/sendDataToParent';

export const getMarkerEventHandlers =
    (
     locationId : number | undefined ,
     latitude : number | undefined ,
     longitude : number | undefined,
     regionType : string | undefined
    ) => {
    return {
        click: () => {

            if ( locationId !== undefined){
                sendDataToParent({ type: 'regionMarker-clicked'   ,locationId ,regionType , latitude , longitude  })
            }

        },
    };
};
